export const UNIFIED_SETTINGS_FEATURES = {
  CHANNEL_DISTRIBUTION_VIEW: 'settings.channel_distribution.view',
  CHANNEL_DISTRIBUTION_EDIT: 'settings.channel_distribution.edit',
  SUBSCRIPTION_PROFILE_VIEW: 'settings.subscription_profile.view',
  SUBSCRIPTION_PROFILE_EDIT: 'settings.subscription_profile.edit',
} as const;

export const GENERAL_PROPERTY_FEATURES = {
  HOTEL_NAME: 'general-property-hotel-name',
  HOTEL_EMAIL: 'general-property-hotel-email',
  HOTEL_ADDRESS: 'general-property-hotel-address',
  HOTEL_WEBSITE: 'general-property-hotel-website',
  HOTEL_PHONE: 'general-property-hotel-phone',
  HOTEL_LANGUAGE: 'general-property-hotel-language',
  HOTEL_COORDINATES: 'general-property-hotel-coordinates',
  HOTEL_TIMEZONE: 'general-property-hotel-timezone',
  HOTEL_LOGO: 'general-property-hotel-logo',
  VAT_RATE: 'general-property-vat-rate',
  CURRENCY: 'general-property-currency',
} as const;

export type GeneralPropertyFeature =
  (typeof GENERAL_PROPERTY_FEATURES)[keyof typeof GENERAL_PROPERTY_FEATURES];
